import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Briefcase, Check, Compass, GraduationCap, Map, MapPin, Monitor, Shield, Sprout, Users, Video } from 'lucide-react';

const assessmentStages = [
  {
    title: 'Class 2-7',
    desc: 'Find out Multiple Intelligence of the student to guide early academic and extracurricular focus.',
    icon: Sprout,
    link: '/services#class-2-7',
  },
  {
    title: 'Class 8-10',
    desc: 'Find out the most suitable career path and subjects - choose between Science, Commerce, or Arts with confidence.',
    icon: Compass,
    link: '/services#class-8-10',
  },
  {
    title: 'Class 11-12',
    desc: 'Find out the most suitable career path and career road map with a detailed execution plan.',
    icon: Map,
    link: '/services#class-11-12',
  },
  {
    title: 'Graduates',
    desc: 'Find out the most suitable career path and career road map with a detailed execution plan after graduation.',
    icon: GraduationCap,
    link: '/services#graduates',
  },
  {
    title: 'Professionals',
    desc: 'Early and mid-career counselling for professionals with a detailed execution plan.',
    icon: Briefcase,
    link: '/services#professionals',
  },
];

const About = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    transition={{ duration: 0.5 }}
  >
    <section className="About_hero__GRcZ1">
      <div className="container About_heroContainer__yGQ5n">
        <motion.span
          className="section-label"
          style={{ color: 'var(--c-gold)' }}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          OUR STORY
        </motion.span>
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
        >
          About Us
        </motion.h1>
        <motion.p
          className="About_heroSubtext__Wr24j"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          Bringing affordable, expert career guidance to students and professionals across Uttar Pradesh.
        </motion.p>
      </div>
    </section>

    <section className="section">
      <div className="container">
        <div className="About_whoWeAre__abc12">
          <div className="About_whoWeAreContent__xyz34">
            <span className="section-label">WHO WE ARE</span>
            <h1>Vitae Career Enterprises</h1>
            <p>
              We, Vitae Career Enterprises cater career counselling services mainly in Lucknow and Balrampur (UP) to help school and college going students and professionals in deciding their career. We believe in — "Timely Acquired Career Guidance Gives Success."
            </p>
            <div className="About_featureGrid__def56">
              <div className="About_featureCard__ghi78">
                <Check size={20} />
                <span>Certified career analyst</span>
              </div>
              <div className="About_featureCard__ghi78">
                <MapPin size={20} />
                <span>Lucknow & Balrampur</span>
              </div>
              <div className="About_featureCard__ghi78">
                <Video size={20} />
                <span>Face-to-face & online</span>
              </div>
            </div>
            <Link to="/about" className="About_learnMore__jkl90">
              Learn More About Us →
            </Link>
          </div>
          <div className="About_visionBox__iI2RU">
            <span className="About_visionLabel__X3cJ8">OUR VISION</span>
            <p className="About_visionText__9p2YG">
              To help school and college going students and professionals in deciding their career by providing counselling in choosing their field of education and career according to their personality, interest, values etc.
            </p>
          </div>
        </div>
      </div>
    </section>

    <section className="section About_stageSection__lmN42">
      <div className="container">
        <div className="About_stageHeader__pqR18">
          <span className="section-label">PSYCHOMETRIC CAREER ASSESSMENT</span>
          <h2>Guidance for Every Stage of Life</h2>
        </div>
        <div className="About_stageGrid__uV76x">
          {assessmentStages.map(({ title, desc, icon: Icon, link }) => (
            <article className="About_stageCard__kY29p" key={title}>
              <span className="About_stageIcon__bC51m">
                <Icon size={30} />
              </span>
              <h3>{title}</h3>
              <p>{desc}</p>
              <Link to={link} className="About_stageLink__tN64a">
                Learn More ->
              </Link>
            </article>
          ))}
        </div>
        <div className="About_stageCta__xD08f">
          <Link to="/services" className="btn-secondary">
            View All Assessments ->
          </Link>
        </div>
      </div>
    </section>

    <div className="About_sectionDivider__gA+jX"></div>

    <section className="section section-alt">
      <div className="container">
        <div className="About_sectionHeader__uq2ct">
          <span className="section-label">THE VITAE DIFFERENCE</span>
          <h2>Why Students & Families Trust Us</h2>
        </div>
        <div className="About_whyGrid__Qn8eY">
          <div className="About_whyCard__BdRow">
            <Shield size={40} className="About_whyIcon__rRbyb" />
            <div>
              <h4>Government-Grade Credibility</h4>
              <p>
                Led by a former Deputy Director General from the Ministry of Information & Broadcasting, our practice operates with the highest levels of integrity, discipline, and accountability.
              </p>
            </div>
          </div>
          <div className="About_whyCard__BdRow">
            <Users size={40} className="About_whyIcon__rRbyb" />
            <div>
              <h4>Science-Backed Methods</h4>
              <p>
                We do not rely on guesswork. Our multi-dimensional psychometric assessments measure aptitude, personality, and interests with precision.
              </p>
            </div>
          </div>
          <div className="About_whyCard__BdRow">
            <Monitor size={40} className="About_whyIcon__rRbyb" />
            <div>
              <h4>Affordable Comprehensive Reports</h4>
              <p>
                A 20+ page detailed analysis — bringing premium career guidance within reach for every family.
              </p>
            </div>
          </div>
          <div className="About_whyCard__BdRow">
            <Check size={40} className="About_whyIcon__rRbyb" />
            <div>
              <h4>Face-to-Face & Online</h4>
              <p>
                Career guidance available in Lucknow, Balrampur, and across India through online counselling sessions.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </motion.div>
);

export default About;
